module.exports = __webpack_public_path__ + "static/media/14.8e8a9c64.jpg";